import React, { useState, useEffect } from "react";
import { errorResponse, failResponse } from "config/config";
import { getAllCourses, getOurSpecialCourses } from "services/courses/courses";
import {
  getMasterCourseCategories,
  getMasterCourseSubCategories,
} from "services/master";
import { Link } from "react-router-dom";


import "./OurSpecialCourses.scss";
import { Pageimg } from "assets/icons";

const OurSpecialCourses = () => {
  const specialcoursecardData = [
    { id: 1, title: "Card One", items: ["Item 1", "Item 2", "Item 3", "Item 4"] },
    { id: 2, title: "Card Two", items: ["Item 1", "Item 2", "Item 3", "Item 4", "Item 5", "Item 6"] },
    { id: 3, title: "Card Three", items: ["Item 1", "Item 2", "Item 3", "Item 4", "Item 5", "Item 6", "Item 7", "Item 8"] },
    { id: 4, title: "Card Four", items: ["Item 1", "Item 2", "Item 3", "Item 4", "Item 5"] },
  ];

  const TYPES = [
    { id: "UPSC", name: "UPSC" },
    { id: "SPSC", name: "State PSC" },
  ];


  const containerHeight = 280;
  const headingHeight = 50;
  const itemHeight = 40;

  const [type, setType] = useState(TYPES[0]?.id);
  const [loading, setLoading] = useState(false);
  const [allCategories, setAllCategories] = useState([]);
  const [allCourses, setAllCourses] = useState([]);


  useEffect(() => {
    // Fetch course categories and subcategories based on the selected type
    const getCourseCategoriesWithSubcategories = async () => {
      try {
        const res = await getMasterCourseCategories({ type });
        if (res.code === 200) {
          const categories = res.data.courseCategories || [];
          const categoriesWithSubcategories = await Promise.all(
            categories.map(async (category) => {
              const subCatRes = await getOurSpecialCourses({
                language: "EN",
                page: 1,
                examType: [],
                courseType: [],
                stateId: [],
                courseCategory: category.id,
                CourseSubCategory: "",
                search: "",
                platformType: "chrome",
              });
              return {
                ...category,
                subcategories: subCatRes.code === 200 ? subCatRes.data.courses.rows || [] : [],
              };
            })
          );
          setAllCourses(categoriesWithSubcategories);
        } else {
          failResponse(res);
        }
      } catch (err) {
        errorResponse(err);
      }
    };
    getCourseCategoriesWithSubcategories();
  }, [type]);

  return (
    <div className="our_courses spacing">
      <div className="container">
        <div className="page_title">
          <h3>Our special courses</h3>
          <p>Our specially designed and most recommended courses for upcoming exams</p>
        </div>
        <div className="specialcoursecards-container">
          {allCourses.map((category) => {
            // Prepare array of { name, path }
            const itemsWithPath = category.subcategories.map((course) => ({
              name: course.DisplayName,
              path: course.staticurlcourses[0]?.staticurl || '#',
            }));

            // Repeat as needed
            const repeats = Math.ceil(((containerHeight - headingHeight) * 2) / (itemsWithPath.length * itemHeight));
            const repeatedItems = Array.from({ length: repeats }, () => itemsWithPath).flat();

            return (
              <div key={category.id} className="specialcoursecard">
                <div className="specialcoursecard-heading">{category.name}</div>
                <div className="scroll-container" data-speed={5 + category.id}>
                  <div className="scroll-content">
                    {repeatedItems.map((item, index) => (
                      <div key={index} className="list-item">
                        <img src={Pageimg} alt="" loading="lazy" />
                        <Link to={item.path}>
                          {item.name}
                        </Link>
                      </div>
                    ))}
                  </div>
                </div>
              </div>
            );
          })}

        </div>
      </div>
    </div>


  );
};

export default OurSpecialCourses;
